export const take = <T extends Record<string | number, any>, O extends Record<string | number, any>>(
  input: Partial<Record<keyof T, any>>,
  ...keys: Array<keyof T>
): Partial<T> => {
  return keys.reduce((acc, k): Partial<O> => {
    const v = input[k];
    if (typeof v === 'undefined') {
      return acc;
    }
    return { ...acc, [k]: v };
  }, {});
};
